export default __webpack_public_path__ + "static/media/Icon awesome-check.d4327491.svg";